import { Workbox } from 'workbox-window';
import toast from 'react-hot-toast';

let wb;

export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    wb = new Workbox('/sw.js');

    wb?.addEventListener('installed', (event) => {
      if (event?.isUpdate) {
        toast?.success('New version available! Refresh to update.', {
          duration: 5000,
          action: {
            label: 'Refresh',
            onClick: () => window.location?.reload()
          }
        });
      }
    });

    wb?.addEventListener('waiting', () => {
      toast('Update ready! Click to refresh.', {
        duration: 0,
        action: {
          label: 'Refresh',
          onClick: () => {
            wb?.messageSkipWaiting();
            window.location?.reload();
          }
        }
      });
    });

    wb?.addEventListener('controlling', () => {
      window.location?.reload();
    });

    wb?.register();

    // Register background sync
    if ('sync' in navigator.serviceWorker) {
      navigator.serviceWorker?.ready?.then((registration) => {
        return registration?.sync?.register('sync-offline-data');
      })?.catch((err) => {
        console.log('Background sync registration failed:', err);
      });
    }
  }
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker?.ready?.then((registration) => {
        registration?.unregister();
      })?.catch((error) => {
        console.error('Service worker unregistration failed:', error);
      });
  }
}

// Check if app is running in standalone mode (installed as PWA)
export function isStandalone() {
  return window.matchMedia('(display-mode: standalone)')?.matches ||
         window.navigator?.standalone === true;
}

// Prompt user to install PWA
export function promptInstall() {
  if (window.deferredPrompt) {
    window.deferredPrompt?.prompt();
    window.deferredPrompt?.userChoice?.then((choiceResult) => {
      if (choiceResult?.outcome === 'accepted') {
        console.log('User accepted the install prompt');
      }
      window.deferredPrompt = null;
    });
  }
}

// Listen for install prompt
window.addEventListener('beforeinstallprompt', (e) => {
  e?.preventDefault();
  window.deferredPrompt = e;
});